import { Table as TableAntd, Flex } from 'antd';
import { FieldArray } from 'formik';
import React, { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import Button from '~/components/Button';
import { useCheckAuth } from '~/components/Can/checkAuth';
import Strong from '~/components/Strong';
import { Table } from '~/components/Table';
import { getServices } from '~/services/hooks/services';
import { servicesEventColumns } from '~/tables/servicesEvent';
import errorHandler from '~/Utils/errorHandler';
import { formatPrice, parsePrice } from '~/Utils/format';

export default function ServiceModal({ values, setFieldValue, setLoading, t, visible, errors, eventRevenues }) {
  const authCheck = useCheckAuth();
  const [services, setServices] = useState([]);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const services = await getServices('', 'no-paginated');
      setServices(services);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const fluidPermissions = () => {
    if (eventRevenues) {
      return !eventRevenues;
    }
    return authCheck('@events/servicesEdit');
  };

  useEffect(() => {
    if (visible) {
      fetchServices();
    }
  }, [visible]);

  return (
    <>
      <FieldArray name={`services_events`}>
        {({ push, remove }) => (
          <Table
            dataSource={values?.services_events?.map((serviceEvents, index) => ({
              ...serviceEvents,
              key: index,
              remove,
            }))}
            columns={servicesEventColumns(services, errors, fluidPermissions, values, setFieldValue)}
            pagination={false}
            size="small"
            rowClassName={() => 'editable-row'}
            bordered
            empty={false}
            summary={() => {
              const totals = values?.services_events?.reduce(
                (acc, se) => {
                  acc.priceTotal += parsePrice(se.price_total);
                  acc.amountTotal += parsePrice(se.amount);

                  return acc;
                },
                {
                  priceTotal: 0,
                  amountTotal: 0,
                }
              );

              return (
                <>
                  <TableAntd.Summary.Row>
                    <TableAntd.Summary.Cell>
                      <Flex style={{ height: '100%' }} align="flex-start" justify="center">
                        <Button
                          color="primary"
                          title="Adicionar operacional"
                          size="small"
                          onClick={() =>
                            push({
                              event_id: values.id,
                              amount: 0,
                              price_unit: 0,
                              price_total: 0,
                              service_id: null,
                            })
                          }
                          style={{ width: '30px' }}
                          disabled={!fluidPermissions()}
                        >
                          <FaPlus />
                        </Button>
                      </Flex>
                    </TableAntd.Summary.Cell>
                  </TableAntd.Summary.Row>
                  <TableAntd.Summary.Row style={{ backgroundColor: '#d6d6d6' }}>
                    <TableAntd.Summary.Cell>
                      <Strong>{t('TOTAL')}</Strong>
                    </TableAntd.Summary.Cell>
                    <TableAntd.Summary.Cell>{totals.amountTotal}</TableAntd.Summary.Cell>
                    <TableAntd.Summary.Cell />
                    <TableAntd.Summary.Cell>{formatPrice(totals.priceTotal)}</TableAntd.Summary.Cell>
                    <TableAntd.Summary.Cell />
                  </TableAntd.Summary.Row>
                </>
              );
            }}
          />
        )}
      </FieldArray>
    </>
  );
}
